import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight } from "lucide-react";

const variantStyles = {
  outline: "btn-outline",
  flat: "btn-flat",
};

let hasHistory = null;

function checkHistory() {
  if (hasHistory === null) {
    hasHistory = window.history.length > 1;
  }
  return hasHistory;
}

export default function BackButton({ to, variant = "outline", className = "", children }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const BackIcon = i18n.language?.startsWith("ar") ? ArrowRight : ArrowLeft;

  if (!to && !checkHistory()) return null;

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${variantStyles[variant]} rounded-sm px-4 py-2 text-xs flex items-center gap-2 ${className}`}
    >
      <BackIcon className="h-3.5 w-3.5" />
      {children || t("booking_details.back")}
    </button>
  );
}
